import React, {Component} from 'react';
import {Col, Form, Row} from "react-bootstrap";


class SelectSlider extends Component {
    constructor(props) {
        super(props);
        const i = this.props.elementProps.options.findIndex(option=>option.value===this.props.elementProps.defaultValue)
        this.state = {
            value:i,
            error:false
        }
    }
    answerBouncer = null
    setAnswer = ()=>{
        clearTimeout(this.answerBouncer)
        this.answerBouncer = setTimeout(()=>{
            const val = this.props.elementProps.options[this.state.value].value
            this.props.setAnswer(val)
        },100)
    }
    handleChange=(e)=>{
        let val = e.target.value
        this.setState({value:val},()=>{
            this.setAnswer()
        })
    }
    select = ()=>{
        const props = {
            value:this.state.value,
            "aria-label":this.props.label,
            isValid:this.props.elementProps.isValid,
            isInvalid:this.props.elementProps.isInvalid,
            onChange:this.handleChange
        }
        return <Form.Select {...props} >
            {
                this.props.elementProps.options.map((opt,i)=>{
                    return <option key={opt.value} value={i}>{opt.text}</option>
                })
            }
        </Form.Select>
        // <Form.Select
        //     isValid={this.state.berRating.value && !this.state.berRating.error}
        //     isInvalid={this.state.berRating.value && this.state.berRating.error}
        //     aria-label="BER Rating"
        //     defaultValue={this.state.berRating.value}
        //     onChange={this.setBerRating}>
        //     <option value="">Select rating</option>
        //     <option value="1">One</option>
        //     <option value="2">Two</option>
        //     <option value="3">Three</option>
        //     <option value="3">I don't know</option>
        // </Form.Select>
    }
    handleRangeChange=(e)=>{
        this.setState({value:e.target.value},()=>{
            this.setAnswer()
        })
    }
    render() {
        return (
            <div className="card input-group-card">
                <Row className="d-flex align-items-center gx-1 pb-2">
                    <Col>
                        <label className=""> {this.props.label} </label>
                    </Col>
                    <Col className="input-col">
                        {this.select()}
                        <Form.Control.Feedback type="invalid">
                            {this.props.elementProps?.isInvalid && this.props.error}
                        </Form.Control.Feedback>
                    </Col>
                </Row>
                <Form.Range step={this.props.step} size={'lg'} min={0} max={this.props.elementProps.options.length -1 } value={this.state.value} onChange={this.handleRangeChange}/>
            </div>
        );
    }
}

export default SelectSlider;